import { SET_CURRENT_PATH, SET_TABS } from '@actions/types'

const initialState = {
  currentPath: '',
  routes: [{
    hasPanicButton: false,
    headerTitle: 'Engage',
    isProtected: true,
    path: '/:personalAccessCode/engage/:engagementId',
    permission: 'engage',
    showHeader: true,
    tab: null
  },
  {
    hasPanicButton: false,
    headerTitle: 'Engage',
    isProtected: true,
    path: '/:personalAccessCode/engage/:engagementId/reply/:replyGuid',
    permission: 'engage',
    showHeader: true,
    tab: null
  },
  {
    hasPanicButton: false,
    headerTitle: 'Engage',
    isProtected: true,
    path: '/:personalAccessCode/engage/:engagementId/reply/:replyGuid/send',
    permission: 'engage',
    showHeader: true,
    tab: null
  },
  {
    hasPanicButton: false,
    headerTitle: 'Priority Connect',
    isProtected: true,
    path: '/:personalAccessCode/priority-connect/:conferenceAlias',
    permission: null,
    showHeader: false,
    tab: null
  },
  {
    hasPanicButton: false,
    headerTitle: 'Priority Connect',
    isProtected: true,
    path: '/:personalAccessCode/priority-connect/:conferenceAlias',
    permission: null,
    showHeader: false,
    tab: null
  },

  // TABS
  {
    hasPanicButton: true,
    headerTitle: 'Messages',
    isProtected: false,
    path: '/:personalAccessCode/messages',
    permission: null,
    showHeader: true,
    tab: {
      display: true,
      icon: 'messages',
      path: 'messages',
      title: 'Messages'
    }
  },
  {
    hasPanicButton: true,
    headerTitle: 'Submit tip',
    isProtected: true,
    path: '/:personalAccessCode/tips',
    permission: 'tips',
    showHeader: true,
    tab: {
      display: true,
      icon: 'tips',
      path: 'tips',
      title: 'Tips'
    }
  },
  {
    hasPanicButton: true,
    headerTitle: 'Resources',
    isProtected: true,
    path: '/:personalAccessCode/resources',
    permission: 'resources',
    showHeader: true,
    tab: {
      display: true,
      icon: 'resources',
      path: 'resources',
      title: 'Resources'
    }
  },
  {
    hasPanicButton: false,
    headerTitle: 'Safe walk',
    isProtected: true,
    path: '/:personalAccessCode/safewalk',
    permission: 'safewalk',
    showHeader: true,
    tab: {
      display: false,
      icon: 'walk',
      path: 'safewalk',
      title: 'Safe walk'
    }
  },
  {
    hasPanicButton: false,
    headerTitle: 'Safe walk',
    isProtected: true,
    path: '/:personalAccessCode/safewalk/off-campus',
    permission: 'safewalk',
    tab: {
      display: false,
      icon: 'walk',
      path: 'safewalk/off-campus',
      title: 'Safe walk'
    }
  },
  {
    hasPanicButton: false,
    headerTitle: 'Safe walk',
    isProtected: true,
    path: '/:personalAccessCode/safewalk/on-campus',
    permission: 'safewalk',
    tab: {
      display: false,
      icon: 'walk',
      path: 'safewalk/on-campus',
      title: 'Safe walk'
    }
  },
  {
    hasPanicButton: false,
    headerTitle: 'Engage',
    isProtected: true,
    path: '/:personalAccessCode/engage',
    permission: 'engage',
    showHeader: true,
    tab: {
      display: false,
      icon: 'settings',
      path: 'engage',
      title: 'Engage'
    }
  }],
  tabs: []
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action

  switch (type) {
  case SET_TABS:
    return {
      ...state,
      tabs: payload
    }
  case SET_CURRENT_PATH:
    return {
      ...state,
      currentPath: payload
    }
  default:
    return state
  }
}

export default reducer
